import { axiosWithAuth } from "@/lib/AxiosClient";
import type { AxiosRequestConfig } from "axios";

export class DownloadService {
  private static instance = axiosWithAuth;

  static async download(
    endpoint: string,
    options: AxiosRequestConfig = {},
    defaultFilename: string = 'downloaded-file.xlsx'
  ): Promise<void> {
    try {
      const response = await this.instance({
        url: endpoint,
        method: options.method || 'GET',
        ...options,
        responseType: 'blob',
      });

      // Extract filename from Content-Disposition header
      const contentDisposition = response.headers['content-disposition'];
      let filename = defaultFilename;

      if (contentDisposition) {
        const starMatch = contentDisposition.match(/filename\*=UTF-8''(.+?)(;|$)/);
        if (starMatch?.[1]) {
          filename = decodeURIComponent(starMatch[1]);
        } else {
          const match = contentDisposition.match(/filename=([^;]+)/);
          if (match?.[1]) {
            filename = match[1].replace(/^"|"$/g, '').trim();
          }
        }
      }

      // Trigger browser download
      const url = window.URL.createObjectURL(response.data);
      const link = document.createElement('a');
      link.href = url;
      link.download = filename;
      document.body.appendChild(link);
      link.click();

      // Cleanup
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error(`Download failed: ${endpoint}`, error);
      throw error;
    }
  }
}